import { Exclude, Type } from 'class-transformer';
import { IsDefined, IsInt, IsOptional } from 'class-validator';

export class NpsPieMerchantCreateDto {
  @Exclude()
  id?: number;

  @IsDefined()
  @IsInt()
  @Type(() => Number)
  pieMerchantId: number;

  @IsOptional()
  @IsInt()
  @Type(() => Number)
  npsId?: number;
}
